import acomPackage from '@catalogo/shell-acom-version';
import subaPackage from '@catalogo/shell-suba-version';
import shopPackage from '@catalogo/shell-shop-version';

const brandVersions = {
  acom: acomPackage.version,
  suba: subaPackage.version,
  shop: shopPackage.version,
};

export default function getVersion(brand) {
  return brandVersions[brand];
}
